namespace RioERP.Web.Enums {
    export enum StatusTypeKey {
        FullyShipped = 1,
        Delivered = 2,
        PartiallyShipped = 3,
        Returned = 4,
        ShippingLater = 5,
        Booked = 6
    }
    Serenity.Decorators.registerEnumType(StatusTypeKey, 'RioERP.Web.Enums.StatusTypeKey');
}
